import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import useInfoCardStyles from './useInfoCardStyles';
import { useNavigate } from 'react-router-dom';
const InfoCard = ({ className, heading, content, icon, right, focused }) => {
    const theme = useTheme();
    const { infoCardStyles } = useInfoCardStyles();
    const navigate = useNavigate();
    const isLightMode = theme.palette.mode === 'light';
    return (_jsxs(Box, { className: `info-card info-card__${className}`, sx: {
            ...infoCardStyles,
            background: focused
                ? (theme) => (isLightMode ? theme.palette.primary.main : theme.palette.primary.light)
                : (theme) => (isLightMode ? theme.palette.common.white : theme.palette.background.paper)
        }, onClick: () => {
            if (heading === 'Active Systems' || heading === 'Total Systems') {
                navigate(`/live-systems`);
            }
            if (heading === 'Total Incidents') {
                navigate(`/incidents`);
            }
        }, children: [_jsx(Typography, { variant: 'subtitle2', color: focused
                    ? isLightMode
                        ? theme.palette.getContrastText(theme.palette.primary.main)
                        : theme.palette.grey[900]
                    : 'textSecondary', children: heading }), _jsx(Typography, { variant: 'h3', color: focused
                    ? isLightMode
                        ? theme.palette.getContrastText(theme.palette.primary.main)
                        : theme.palette.grey[900]
                    : 'textSecondary', children: content }), icon && _jsx("img", { src: icon, alt: 'info-card-icon', style: { right } })] }));
};
export default InfoCard;
